module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "youtube-section"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('h2'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeOut",
      "mode": "out-in"
    }
  }, [(!_vm.loading && _vm.lowcoGamesVideos !== null && _vm.lowcoVideos !== null) ? _c('div', [_c('h2', [_c('a', {
    staticClass: "link-btn",
    attrs: {
      "href": "https://www.youtube.com/channel/UC3GZtOeb7Pe2HVYYPk6ilnA",
      "aria-label": "external link: Lowco youtube channel",
      "title": "Lowco youtube channel"
    }
  }, [_vm._v("Lowco")])]), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper"
  }, _vm._l((_vm.lowcoVideos), function(lowcoVideo) {
    return _c('youtube-video', {
      key: lowcoVideo.id.videoId,
      attrs: {
        "videoId": lowcoVideo.id.videoId
      }
    })
  }), 1), _vm._v(" "), _c('h2', [_c('a', {
    staticClass: "link-btn",
    attrs: {
      "href": "https://www.youtube.com/user/Lowco2525",
      "aria-label": "external link: lowcogames youtube channel",
      "title": "Lowco youtube channel"
    }
  }, [_vm._v("Lowco Games")])]), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper"
  }, _vm._l((_vm.lowcoGamesVideos), function(video) {
    return _c('youtube-video', {
      key: video.$index,
      attrs: {
        "videoId": video.contentDetails.videoId
      }
    })
  }), 1)]) : _c('loading-spinner', {
    staticClass: "loading"
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b2b1f05","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/YoutubeSection.vue
// module id = 1166
// module chunks = 2